import { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { FormikProps } from 'formik';
import { useNavigate, useParams } from 'react-router-dom';
import { MerchantCatalogBase } from 'src/app/api/openapi';

const CreateCatalogForm = ({
  submitForm,
  getFieldProps,
  values,
  setFieldValue,
}: FormikProps<MerchantCatalogBase>) => {
  const { catalogId } = useParams();
  const [showDatePickers, setShowDatePickers] = useState(
    !!(values.availability_start || values.availability_end)
  );
  const navigate = useNavigate();

  return (
    <>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h1">
          {catalogId ? 'Edit' : 'Create'} Catalog
        </Typography>
        <Box>
          <Button variant="text" onClick={() => navigate(-1)} sx={{ mr: 2 }}>
            Cancel
          </Button>
          <Button variant="flat" onClick={submitForm}>
            {catalogId ? 'Save' : 'Create'}
          </Button>
        </Box>
      </Stack>
      <Stack>
        <TextField
          label="Name"
          {...getFieldProps('name')}
          sx={{ m: 1, width: '97%' }}
        />
        <FormControlLabel
          label="Specify dates this catalog is available for import"
          control={
            <Switch
              checked={showDatePickers}
              onChange={() => {
                if (showDatePickers) {
                  setFieldValue('availability_start', null);
                  setFieldValue('availability_end', null);
                }
                setShowDatePickers(!showDatePickers);
              }}
              sx={{ m: 2 }}
            />
          }
        />
        {showDatePickers ? (
          <Stack direction="row">
            <DatePicker
              label="Availability Start"
              value={dayjs(values.availability_start)}
              onChange={(value) => {
                setFieldValue('availability_start', value);
              }}
              slotProps={{
                textField: { error: false },
              }}
              sx={{ m: 1, width: '100%' }}
            />
            <DatePicker
              label="Availability End"
              value={dayjs(values.availability_end)}
              onChange={(value) => {
                setFieldValue('availability_end', value);
              }}
              slotProps={{
                textField: { error: false },
              }}
              sx={{ m: 1, width: '100%' }}
            />
          </Stack>
        ) : null}
      </Stack>
    </>
  );
};

export default CreateCatalogForm;
